<app-container class="form-container border-none" title="Create a new password">
	<form [formGroup]="resetForm" (ngSubmit)="submit()">
		<div class="flex">Welcome back {{ email }}</div>
		<div class="flex text-xs mt-2">
			Passwords must be at least 8 characters long, and contain a number,
			capital, lowercase & special character.
		</div>
		<div class="flex mt-4">
			<app-input
				[touched]="resetForm.controls[RESET.NEW_PASSWORD].touched"
				[required]="true"
				label="New Password"
				formControlName="{{ RESET.NEW_PASSWORD }}"
				type="password"
			></app-input>
		</div>
		<div class="flex mt-3">
			<app-input
				[required]="true"
				label="Re-enter New Password"
				formControlName="{{ RESET.CONFIRM_PASSWORD }}"
				type="password"
			></app-input>
		</div>
		<div class="flex mt-5 justify-center">
			<app-button type="submit" cssClasses="button w-full" class="w-full"
				>Save & Go to Log in</app-button
			>
		</div>
	</form>
</app-container>
